export const LandingPageApiUrls = {
  createConnectionRequest: "helpdesk/CreateConnectionRequest",
  getVitrineAssesses: "user/getVitrineAssesses",
};

export default class landingPageAPI {
  constructor(httpsClient, cache) {
    this.httpsClient = httpsClient;
    this.cache = cache;
  }

  async createConnectionRequest(data, token) {
    return this.post(LandingPageApiUrls.createConnectionRequest, data, token, true, true);
  }

  async getVitrineAssesses(data, token) {
    return this.get(LandingPageApiUrls.getVitrineAssesses, data, token);
  }

  async get(url, data, token, eAlert, sAlert) {
    return await this.httpsClient.get(url, data, token, eAlert, sAlert);
  }

  async post(url, data, token, eAlert, sAlert) {
    this.cache.remove("tests");

    return await this.httpsClient.post(url, data, token, eAlert, sAlert);
  }
}
